import axios from "axios";
import * as Urls from "../constants/Urls";


export const getList = () => axios.get(Urls.REMEDY_LIST_URL);

export const getItem = (id) => axios.get(Urls.remedyUrl(id));

export const addItem = (remedy) => axios.post(Urls.REMEDY_ADD_URL,remedy);

export const editItem = (id,remedy) => axios.post(Urls.remedyEditUrl(id),remedy);